import { PURCHASE_URL, PURCHASE_PAYMENT_URL, REPORTS_URL, restaurant_report_wip_POST, requisitionReport_POST, restaurentReportDailyConsumption, stockHistory_Report } from '../../CONSTANTS'
import { SYSTEM_ERROR } from "../../config/CONSTANTS";
import axios from 'axios'
import Cookies from 'universal-cookie';

const urlParams = new URLSearchParams(window.location.search);
const cook = new Cookies().get('loginData1')
const authToken = urlParams.get("at");

const headersdata = {
    'content-type': 'application/json',
    'Accept': 'application/json',
    'Authorization': cook != undefined ? cook.accessToken : authToken ? authToken : ''
}

export const purchaseProjectionReport = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(PURCHASE_URL() + "purchaseProjectionReport", data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const issueReport = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(PURCHASE_URL() + "issueReport", data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const requisitionReport = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(requisitionReport_POST, data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const grnReport = (data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(PURCHASE_URL() + "grnReport", data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const stockReport = (payload) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(PURCHASE_URL() + "stockReportByCategoryId", payload, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const stockHistory = (payload) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(stockHistory_Report,payload, { headers: headersdata,})
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const stockTransferReport = (warehouseId) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(REPORTS_URL + "StockTransferReport", { warehouseId }, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const stockTransferItemReport = (warehouseId, uuid) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(REPORTS_URL + "StockTransferReport", { warehouseId: warehouseId, uuid: uuid }, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const stockTransferByItemReport = (payload) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(REPORTS_URL + "stockTransferByItemReport", payload, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in stockTransferByItemReport axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const wipReport = (request) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(REPORTS_URL + "wipReport", {
                    departmentId: request.departmentId,
                    organisationId: request.organisationId,
                    warehouseId: request.warehouseId
                }, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    console.error(err);
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const resturantWipReport = (request) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(restaurant_report_wip_POST, {
                    departmentId: request.departmentId,
                    warehouseId: request.warehouseId,
                    endDate: request?.endDate,
                    startDate: request?.startDate

                }, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    console.error(err);
                    reject("Error in getItemList axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const DailyConsumptionReport = (request) => {
    return new Promise((resolve, reject) => {
        try {
            axios.post(restaurentReportDailyConsumption, { startDate: request?.startDate, endDate: request?.endDate,warehouseId: request?.warehouseId  }, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                })
        }
        catch (error) {
            reject(SYSTEM_ERROR);
        }
    })
}

export const nonMovingItemReport = (payload) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(REPORTS_URL + "nonMovingItemReport", payload, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in nonMovingItemReport axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
